import { useAppBridge } from '@shopify/app-bridge-react'
import type { ShopifyAppBridge } from '../../shopifyApiFetch'
import { HomePageView } from './HomePageView'
import { useHome } from './useHome'

/**
 * TestFeed app home container, mounted on the real route by HomeRoute.tsx, which wraps this in
 * <HomeEnvContext.Provider value={{ state, api, navigate }}>. Calls useHome()/useAppBridge() and renders
 * the presentational HomePageView — Ladle stories render HomePageView directly instead of this
 * container, so they don't need a real App Bridge or backend.
 */
export function HomePage() {
  const { state, busy, actions } = useHome()
  const shopify = useAppBridge()
  return <HomePageView state={state} busy={busy} actions={actions} shopify={shopify as unknown as ShopifyAppBridge} />
}
